'use client';

export default function AboutStory() {
  return (
    <section className="grid gap-6 rounded-[28px] bg-white p-6 shadow-[0_15px_40px_rgba(34,58,39,0.08)] md:grid-cols-[1.2fr_0.8fr] md:gap-8 md:rounded-[32px] md:p-12">
      <div className="flex flex-col justify-center gap-6">
        <p className="text-sm uppercase tracking-[0.24em] text-[#7F6B48]">
          Câu chuyện Mộc Phúc Duyên
        </p>
        <h2 className="text-xl font-semibold text-[#223A27] sm:text-2xl md:text-4xl">
          Hương trà Việt, tâm hồn an nhiên
        </h2>
        <p className="text-sm leading-7 text-[#5C5A52] sm:text-base md:leading-8">
          Từ năm 2026, Mộc Phúc Duyên bắt đầu hành trình kết nối những đồi trà thơm nắng cùng tay nghề chăm chút của những người yêu trà. Chúng tôi tin rằng mỗi tách trà là một câu chuyện, một khoảnh khắc chậm rãi để sống trọn với chính mình.
        </p>
        <p className="text-sm leading-7 text-[#5C5A52] sm:text-base md:leading-8">
          Mộc Phúc Duyên chọn lọc nguyên liệu từ các vùng trà nổi tiếng, bảo tồn nét tinh túy truyền thống và tạo nên trải nghiệm trà gần gũi, thanh khiết trong từng lần thưởng thức.
        </p>
      </div>

      <div className="rounded-[24px] bg-[#F7F1E6] p-5 text-[#423823] shadow-[0_10px_30px_rgba(34,58,39,0.06)] md:rounded-[28px] md:p-6">
        <h3 className="mb-4 text-xl font-semibold">Tinh thần trà</h3>
        <p className="text-sm leading-7">
          Trà không chỉ là thức uống, mà còn là hành trình gắn kết con người với thiên nhiên. Mộc Phúc Duyên kể câu chuyện đó bằng vị trà thanh tao, không cầu kỳ, chỉ trọn vẹn và mộc mạc.
        </p>
      </div>
    </section>
  );
}
